export default {
  // albumBucketName: 'tkio-prd-cnbej-92867-dabhcpmicroseg-001',
  // region: 'cn-north-1',
  // accessKeyId: 'AKIA4MUSM6DT7HPQB6W7',
  // secretAccessKey: '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'
  // lundbeck
  albumBucketName: 'lundbeck-superrep-hcp360-sandbox',
  region: 'cn-northwest-1',
  accessKeyId: 'AKIA3SIRKMIYSJNHRNUC',
  secretAccessKey: '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'
};
